export const SET_WORKFLOWS = 'SET_WORKFLOWS';
export const CLEAR_WORKFLOWS = 'CLEAR_WORKFLOWS';
